<div id="<?=cid?>-accuracy" class="acuracy-warning alert alert-danger p-1 m-0 text-center small d-none"></div>

<div class="pt-2 pb-2 px-3 bb">
	<div class="d-flex justify-content-between align-items-center">
		<div class="d-flex justify-content-start align-items-center">
			<div><i class="far fa-2x fa-map-marker-alt color-green"></i></div>
			<div class="ml-2">
				<small><?=label?></small><br/>
				<strong id="<?=cid?>-lat"><em class="small color-red">Veuillez activer la géolocalisation</em></strong>&nbsp;&nbsp;<strong id="<?=cid?>-lng"></strong>
			</div>
		</div>
		<div>
			<a href="#" class="js-reset-position">
				<i class="ml-3 color-green fas fa-sync-alt"></i>
			</a>
		</div>
	</div>
</div>

<div id="<?=cid?>-map-type" class="row no-gutters bb text-center small fw-600">
	<a href="#" data-type="plan" class="js-map-type col text-secondary py-1 br" style="text-decoration: none;">Plan</a>
	<a href="#" data-type="ign" class="js-map-type col text-secondary py-1 br" style="text-decoration: none;">Satellite</a>
	<a href="#<?=cid?>-legend" data-toggle="modal" class="col-auto text-info px-3 py-1" style="text-decoration: none;"><i class="fa fa-info-circle"></i></a>
</div>

<div id="<?=cid?>-map" style="height:50vh">
	<div class="bg-secondary h-100 text-center d-flex justify-content-center align-items-center">
		<i class="far fa-map-marker-question fa-7x text-light"></i>
	</div>
</div>

<div id="<?=cid?>-legend" class="modal">
	<div class="moda-dialog modal-dialog-centered">
		<div class="modal-content mx-3">
			<div class="modal-header">
				<strong class="color-green modal-title">Légende de la carte</strong>
			</div>
			<ul class="list-group list-group-flush">
				<? _.each( status_list, function( status ) { ?>
					<li class="list-group-item"><i class="fa fa-circle text-<?=status.class?> mr-1"></i> Mare <?=status.name.toLocaleLowerCase()?></li>
				<? }) ?>
				<li class="list-group-item"><i class="far fa-plus-circle pulse mr-1" style="color: #212529"></i> Votre position sur la carte</li>
<!-- 				<li class="list-group-item"><i class="far fa-question-circle pulse mr-1" style="color: #6c757d"></i> Erreur de géolocalisation</li> -->
			</ul>
			<div class="modal-footer">
				<button type="button" data-dismiss="modal" class="btn btn-outline-secondary">Fermer</button>
			</div>
		</div>
	</div>
</div>
